/**
 * Safely escapes HTML special characters to prevent XSS attacks
 * 
 * @param {string} html - The HTML string to escape
 * @returns {string} - The escaped HTML string
 */
export function escapeHtml(html) {
    if (!html) return '';
    return String(html)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

/**
 * Safely decodes HTML entities to plain text
 * 
 * @param {string} html - The HTML string to decode
 * @returns {string} - The decoded plain text
 */
export function decodeHtml(html) {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.documentElement.textContent;
}
